import { render, staticRenderFns } from "./md-button-selector.vue?vue&type=template&id=637689fb&"
import script from "./md-button-selector.vue?vue&type=script&lang=js&"
export * from "./md-button-selector.vue?vue&type=script&lang=js&"
import style0 from "./md-button-selector.vue?vue&type=style&index=0&id=637689fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports